// 可能是最后一个商品组件库
// 目前项目中存在重复实现商品列表的情况，对列表样式，显示逻辑调整的修改特别麻烦
// 这个库的目的是统一整个项目商品列表的实现

// 商品列表元素存在 3 种形态：
//   1. 一排一列 4:3 1-1/4:3
//   2. 一排一列 16:9 1-1/16:9
//   3. 一排两列 3:2 1-2/3:2 Layouts/1-1/s4:3

// 商品标签有两大类：
//   1. 售卖标签（商品的售卖属性）
//   2. 优惠标签

import React from 'react';
import * as PropTypes from 'prop-types';
import cx from 'classnames';
import S4x3 from './Layouts/1-1/S4x3';
import S16x9 from './Layouts/1-1/S16x9';
import S3x2 from './Layouts/1-2/S3x2';
import * as navigation from '../../util-lib/navigation';
import './style.scss';

const layoutMap = {
  '1-1': {
    '4x3': S4x3,
    '16x9': S16x9
  },
  '1-2': {
    '3x2': S3x2
  }
};

const URL = '/tantu/goods/goods.php';

const GoodsUI = (
  {
    tag: Wrapper = 'div',
    className,
    layout,
    scale,
    data,
    urlQuery = {},
    discountLabelsAlign,
    onClick,
    dataTransformer,
    ...rest
  }
) => {
  const scaleMap = layoutMap[layout];
  if (!scaleMap) {
    return null;
  }
  const Component = scaleMap[scale];
  if (!Component) {
    return null;
  }
  const transformedData = (
    dataTransformer && dataTransformer.call
  ) ? dataTransformer.call(null, data) : data;
  return (
    <Wrapper
      className={cx('component-goods-ui', className)}
      onClick={bindOnClick(onClick, data, urlQuery)}
      {...rest}
    >
      <Component data={transformedData} discountLabelsAlign={discountLabelsAlign} />
    </Wrapper>
  );
};

const bindOnClick = (onClick, data, urlQuery) => () => {
  if (onClick && onClick.call) {
    onClick(data);
  }
  navigation.push(URL, {
    goods_id: data.id,
    ...urlQuery
  });
};

GoodsUI.propTypes = {
  tag: PropTypes.string,
  className: PropTypes.string,
  layout: PropTypes.string,
  scale: PropTypes.string,
  data: PropTypes.shape({}).isRequired,
  urlQuery: PropTypes.shape({}),
  discountLabelsAlign: PropTypes.string,
  onClick: PropTypes.func,
  dataTransformer: PropTypes.func
};

export { S4x3, S16x9, S3x2 };
export default GoodsUI;
